import client from "utils/api";
import analytics from 'utils/analytics'

function createAccount(data){
  return client().post(`/accounts`,data)
    .then((response) => {
      analytics.track("create_account")
      return response.data
    }).catch(err=>{})
}
function getFacebookAccounts(token,id){
  return client().post(`/users/facebook/accounts`,{token, id})
    .then((response) => {
      return response.data
    }).catch(err=>{})
}
function addFacebook(data){
  return client().post(`/users/me/facebook`,data)
}
export default {
  createAccount,
  getFacebookAccounts,
  addFacebook
}



// WEBPACK FOOTER //
// ./src/components/setup/api.js